import type { Theme } from '@mildang/mui';
import type { Components } from '@mildang/mui';

const createDialog = (theme: Theme): Components => ({
  MuiDialog: {
    styleOverrides: {
      root: {
        '& .MuiPaper-root': {
          borderRadius: 16,
        },
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: '24px 24px 20px 24px',
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.background.secondary,
        padding: '16px 24px',
        '&>:not(:first-of-type)': {
          marginLeft: 16,
        },
      },
    },
  },
  MuiDialogContentText: {
    styleOverrides: {
      root: {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: '28px',
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: '24px',
      },
    },
  },
});

export default createDialog;
